/**
 * Small choices a person makes on a screen (a period, a collapsed section), remembered in this
 * browser for this person. Never anything that must survive: the storage may be cleared,
 * blocked or missing, and then the screen starts from its defaults.
 */
const key = (user, name) => `addcrm:view:${user || 'anyone'}:${name}`

export function readPref(user, name, fallback) {
  try {
    const raw = window.localStorage.getItem(key(user, name))
    return raw === null ? fallback : JSON.parse(raw)
  } catch {
    return fallback
  }
}

export function writePref(user, name, value) {
  try {
    window.localStorage.setItem(key(user, name), JSON.stringify(value))
  } catch {
    // not remembered; the choice still holds on this screen
  }
}
